import { Component, Input, Output, EventEmitter, AfterViewInit, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'bc-upload',
  templateUrl: 'bc.upload.component.html',
  styleUrls: ['bc.upload.component.scss']
})
export class BcUploadComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() accept: string;
  @Input() type: string;
  @Input() file: File;

  @Output() filesChanged = new EventEmitter();

  @ViewChild('input', { static: true }) input: any;

  dragDrop: boolean;
  dragOver: boolean;

  url: string;
  fileInternal: File | null;
  validFileSize = 10485760; // 10Mb

  fileTypes: Array<string> = [];
  fakeInput: any = {
    dirty: false,
    errors: {}
  };

  constructor(public sanitizer: DomSanitizer) {
    this.fileInternal = null;
    this.url = '';
  }

  ngAfterViewInit() {
    if (this.accept) {
      this.input.nativeElement.setAttribute('accept', this.accept);
      this.convertAcceptArray();
    }
  }

  ngOnInit() {
    if (this.file) {
      this.addFile(this.file);
      this.filesChanged.emit(this.file);
    }
  }

  ngOnDestroy() {
    this.url = '';
  }

  change(event: any) {
    if (!event.target.files || event.target.files.length === 0) return;

    if (this.isFileValid(event.target.files[0])) this.addFile(event.target.files[0]);
    this.input.nativeElement.value = '';
    this.filesChanged.emit(this.fileInternal);
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  remove() {
    this.fileInternal = null;
    this.file = null;
    this.url = '';
    this.filesChanged.emit(null);
    this.clearUrl(this.url);
    this.dragDrop = false;
    this.dragOver = false;
  }

  onDrop(event: any) {
    if (this.isFileValid(event.dataTransfer.files[0])) this.addFile(event.dataTransfer.files[0]);
    this.filesChanged.emit(this.fileInternal);
    event?.preventDefault();
  }

  onDragEnter() {
    this.dragOver = true;
  }

  onDragOver() {
  }

  onDragLeave() {
    this.dragOver = false;
  }

  addFile(file: File) {
    this.fileInternal = file;
    this.url = (this.fileInternal.type === 'application/pdf') ? '' : this.makeUrl(file);
    this.dragDrop = true;
    this.dragOver = false;

    return this.url;
  }

  sanUrl(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.url);
  }

  private makeUrl(file: File) {
    return window.URL.createObjectURL(file);
  }

  private clearUrl(url: any) {
    window.URL.revokeObjectURL(url);
  }

  private convertAcceptArray() {
    this.fileTypes = this.accept.split(', ');
    const imageIdx: number = this.fileTypes.indexOf('image/*');
    if (imageIdx !== -1) {
      this.fileTypes = this.fileTypes.concat(['image/png', 'image/jpg', 'image/jpeg', 'image/gif']);
    }
  }

  private checkFileName(file: File) {
    return file.name.match(/[&/\\#,+()$~%":*?<>{}]/g);
  }

  private isFileValid(file: File) {
    this.fakeInput.dirty = true;

    if (file.size > this.validFileSize) {
      this.fakeInput.errors = {
        fileSize: true
      };

      return false;
    } else if (this.fileTypes.indexOf(file.type) === -1) {
      this.fakeInput.errors = {
        fileType: true
      };

      return false;
    } else if (this.checkFileName(file) != null) {
      this.fakeInput.errors = {
        fileName: {
          wrong_character: this.checkFileName(file)
        }
      };

      return false;
    } else {
      this.fakeInput.dirty = false;
      this.fakeInput.errors = {};

      return true;
    }
  }
}
